<template>
  <b-button :variant="myVariant" v-bind="$attrs" v-on="$listeners" style="position: relative" :class="{'in-progress': state >= 1, 'p-0': state === 2}"
    :disabled="state === 1" :size="size">
    <div :class="{'invisible': state === 1 }" v-if="state < 2" class="d-inline"><slot /></div>

    <b-spinner small class="spin-style" :class="{'d-inline-block': state === 1}"></b-spinner>

    <b-progress striped animated :height="progressHeight" v-if="state === 2">
      <b-progress-bar :value="100"><slot name="progressText" :progress="progress">{{progress}}%</slot></b-progress-bar>
    </b-progress>

    <div v-if="state === 3" class="d-inline"><slot name="progressComplete"/></div>
  </b-button>
</template>

<script>
import isNumber from 'lodash/isNumber';

export default
{
    beforeDestroy()
    {
        clearTimeout(this.resetTimeout);
    },
    computed:
    {
        myVariant()
        {
            switch (this.state)
            {
                case 0: return this.variant;
                case 1: return this.variant;
                case 2: return this.variant;
                case 3: return 'success';
            }
        },
        progressHeight()
        {
            switch (this.size)
            {
                case 'sm': return '2.5em';
                case '': return '3.25em';
            }
        }
    },
    data()
    {
        let state = 0;

        if(this.busy)
            state = 1;

        return {
            state, // 0 = initial state, 1 = busy (no progress), 2 = busy (progress), 3 = finished (progress)
            resetTimeout: 0
        }
    },
    methods:
    {
        progress100()
        {
            this.state = 3;
            this.resetTimeout = setTimeout(() => this.state = 0, 5000);
            this.$emit('finished');
        }
    },
    mounted()
    {
        /*if(this.progress === 100)
            this.progress100();
        else if(isNumber(this.progress))
            this.state = 2;*/
        if(isNumber(this.progress) && this.progress !== 100)
            this.state = 2;
        else if(isNumber(this.progress) && this.progress === 100)
            this.state = 0;
    },
    props:
    {
        disabled: {},
        busy:     { type: Boolean, required: false },
        progress: { type: Number, required: false },
        variant:  { type: String, required: false },
        size:     { type: String, required: false, default() { return ''} }
    },
    watch:
    {
        busy(value)
        {
            if(value)
                this.state = 1;
            else
                this.state = 0;
        },
        progress(value)
        {
            if(value === 100)
                this.progress100();
            else
                this.state = 2;
        }
    },
}
</script>

<style scoped>
.spin-style
{
    display: none;
    position: absolute;
    width: 16px;
    height: 16px;
    top: calc(50% - 8px);
    left: 50%;
    margin-left: -8px;
}

.in-progress
{
    pointer-events: none;
}
</style>